<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'tipo_receitasCrud'"
          crudName="Tipos  de Receita"
          newText="Novo Tipo Receita"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "tipo_receitasTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "nome",
        "tipo_substancia",
        "controle",
        "limite_prescricao",
        "limite_receita",
        "actions",
      ],
      tableData: [
        "id",
        "nome",
        "tipo_substancia",
        "controle",
        "limite_prescricao",
        "limite_receita",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome", "tipo_substancia", "controle"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Lista",
          tipo_substancia: "Tipo de substância",
          controle: "Controle",
          limite_prescricao: "Limite de prescrição",
          limite_receita: "Limite por receita",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "tipo_receitas",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        tipo_substancia: "tipo_substancia",
        controle: "controle",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>